import { render, staticRenderFns } from "./PersonRecord.vue?vue&type=template&id=2bd4e1de&scoped=true"
import script from "./PersonRecord.vue?vue&type=script&lang=js"
export * from "./PersonRecord.vue?vue&type=script&lang=js"
import style0 from "./PersonRecord.vue?vue&type=style&index=0&id=2bd4e1de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4e1de",
  null
  
)

export default component.exports